export default "__VITE_ASSET__C2EQG1fk__"